import React from "react";

const HomeSvg = () => {
  return (
    <div className="my-80">
      <svg

        className="w-[400px] h-[500px] xl:h-full xl:w-full"

        width="618"
        height="835"
        viewBox="0 0 618 835"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M245.604 15.5276C253.723 11.3906 263.659 14.6189 267.796 22.7384L548.362 573.38C552.499 581.5 549.271 591.436 541.152 595.573C533.032 599.71 523.096 596.482 518.959 588.362L238.393 37.7201C234.256 29.6006 237.484 19.6647 245.604 15.5276Z"
          fill="url(#paint0_linear_237_594)"
        />
        <path
          d="M245.604 15.5276C253.723 11.3906 263.659 14.6189 267.796 22.7384L548.362 573.38C552.499 581.5 549.271 591.436 541.152 595.573C533.032 599.71 523.096 596.482 518.959 588.362L238.393 37.7201C234.256 29.6006 237.484 19.6647 245.604 15.5276Z"
          fill="url(#paint1_linear_237_594)"
        />
        <path
          d="M245.604 15.5276C253.723 11.3906 263.659 14.6189 267.796 22.7384L548.362 573.38C552.499 581.5 549.271 591.436 541.152 595.573C533.032 599.71 523.096 596.482 518.959 588.362L238.393 37.7201C234.256 29.6006 237.484 19.6647 245.604 15.5276Z"
          fill="url(#paint2_linear_237_594)"
        />
        <path
          d="M161.999 136.76C170.118 132.623 180.054 135.851 184.191 143.971L464.757 694.613C468.894 702.732 465.666 712.668 457.546 716.805C449.427 720.942 439.491 717.714 435.354 709.594L154.788 158.952C150.651 150.833 153.879 140.897 161.999 136.76Z"
          fill="url(#paint3_linear_237_594)"
        />
        <path
          d="M79.5465 245.046C87.6659 240.909 97.6018 244.137 101.739 252.257L382.305 802.899C386.442 811.018 383.214 820.954 375.094 825.091C366.975 829.228 357.039 826 352.902 817.88L72.3357 267.238C68.1986 259.119 71.427 249.183 79.5465 245.046Z"
          fill="url(#paint4_linear_237_594)"
        />
        <path
          d="M234.06 826.492C225.987 822.264 222.87 812.293 227.097 804.22L524.946 235.446C529.174 227.373 539.145 224.256 547.218 228.484C555.29 232.711 558.408 242.682 554.18 250.755L256.331 819.529C252.104 827.602 242.132 830.719 234.06 826.492Z"
          fill="url(#paint5_linear_237_594)"
        />
        <path
          d="M234.06 826.492C225.987 822.264 222.87 812.293 227.097 804.22L524.946 235.446C529.174 227.373 539.145 224.256 547.218 228.484C555.29 232.711 558.408 242.682 554.18 250.755L256.331 819.529C252.104 827.602 242.132 830.719 234.06 826.492Z"
          fill="url(#paint6_linear_237_594)"
        />
        <path
          d="M234.06 826.492C225.987 822.264 222.87 812.293 227.097 804.22L524.946 235.446C529.174 227.373 539.145 224.256 547.218 228.484C555.29 232.711 558.408 242.682 554.18 250.755L256.331 819.529C252.104 827.602 242.132 830.719 234.06 826.492Z"
          fill="url(#paint7_linear_237_594)"
        />
        <path
          d="M156.692 720.645C148.619 716.418 145.502 706.447 149.729 698.374L447.578 129.6C451.806 121.527 461.777 118.41 469.85 122.637C477.923 126.865 481.04 136.836 476.812 144.909L178.963 713.683C174.736 721.756 164.764 724.873 156.692 720.645Z"
          fill="url(#paint8_linear_237_594)"
        />
        <path
          d="M70.0809 605.663C62.0081 601.435 58.8908 591.464 63.1183 583.391L360.967 14.617C365.195 6.54424 375.166 3.42702 383.239 7.65448C391.312 11.8819 394.429 21.8533 390.202 29.926L92.3524 598.7C88.125 606.773 78.1537 609.89 70.0809 605.663Z"
          fill="url(#paint9_linear_237_594)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_237_594"
            x1="437.388"
            y1="355.58"
            x2="183.311"
            y2="485.039"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#081F5C" />
            <stop offset="0.0001" stopColor="#E7EAF1" />
            <stop offset="1" stopColor="#1141C2" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_237_594"
            x1="437.388"
            y1="355.58"
            x2="183.311"
            y2="485.039"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#081F5C" />
            <stop offset="0.0001" stopColor="#E7EAF1" />
            <stop offset="1" stopColor="#1141C2" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_237_594"
            x1="437.388"
            y1="355.58"
            x2="183.311"
            y2="485.039"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#081F5C" />
            <stop offset="0.0001" stopColor="#E7EAF1" />
            <stop offset="1" stopColor="#1141C2" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_237_594"
            x1="437.388"
            y1="355.58"
            x2="183.311"
            y2="485.039"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#081F5C" />
            <stop offset="0.0001" stopColor="#E7EAF1" />
            <stop offset="1" stopColor="#1141C2" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_237_594"
            x1="437.388"
            y1="355.58"
            x2="183.311"
            y2="485.039"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#081F5C" />
            <stop offset="0.0001" stopColor="#E7EAF1" />
            <stop offset="1" stopColor="#1141C2" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_237_594"
            x1="184.311"
            y1="351.961"
            x2="432.988"
            y2="482.185"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#081F5C" />
            <stop offset="0.0001" stopColor="#E7EAF1" />
            <stop offset="1" stopColor="#1141C2" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_237_594"
            x1="184.311"
            y1="351.961"
            x2="432.988"
            y2="482.185"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#081F5C" />
            <stop offset="0.0001" stopColor="#E7EAF1" />
            <stop offset="1" stopColor="#1141C2" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_237_594"
            x1="184.311"
            y1="351.961"
            x2="432.988"
            y2="482.185"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#081F5C" />
            <stop offset="0.0001" stopColor="#E7EAF1" />
            <stop offset="1" stopColor="#1141C2" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_237_594"
            x1="184.311"
            y1="351.961"
            x2="432.988"
            y2="482.185"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#081F5C" />
            <stop offset="0.0001" stopColor="#E7EAF1" />
            <stop offset="1" stopColor="#1141C2" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_237_594"
            x1="184.311"
            y1="351.961"
            x2="432.988"
            y2="482.185"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#081F5C" />
            <stop offset="0.0001" stopColor="#E7EAF1" />
            <stop offset="1" stopColor="#1141C2" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default HomeSvg;
